import {styled} from '@volkswagen-onehub/components-core';
import * as React from 'react';

const StyledSlide = styled.div`
    scroll-snap-align: start;
    scroll-snap-stop: always;
    width: 100%;
    height: 100%;
`;

export type SlideProps = Readonly<{
    slide: JSX.Element;
    id: string;
    ariaLabelledBy: string;
    // Note: headingLabel is used as the accessible label in the Bulletpagination
    headingLabel: string;
}>;

export const Slide = ({slide, id, ariaLabelledBy}: SlideProps) => {
    return (
        <StyledSlide id={id} role="tabpanel" aria-labelledby={ariaLabelledBy}>
            {slide}
        </StyledSlide>
    );
};
